// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_naR","cls2":"Search-cls2_d-y Search-cls1_naR"};